import { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLatters'
import './index.scss'
import { NavLink } from 'react-router-dom'
import { SiBootstrap, SiCss3, SiFreecodecamp, SiGeeksforgeeks, SiHtml5, SiJavascript, SiLeetcode, SiMongodb, SiNextdotjs, SiNodedotjs, SiNpm, SiPostman, SiPython, SiReact, SiStackoverflow, SiTailwindcss, SiVercel, SiVisualstudiocode, SiVite } from "react-icons/si";
import Loader from 'react-loaders'


import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

export default function About(){
    const [letterClass,setLetterClass]=useState('text-animate')
    useEffect(()=>{
        setTimeout(()=>{
            setLetterClass('text-animate-hover')
        },3000)
    })
    return(
        <>
            <div className='about-page'>
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters strAry={[...'About Me'.split('')]} letterClass={letterClass} idx={12}/>
                    </h1>
                    <div className='paragraph'>
                        <p className='p-1'>
                        As a full stack developer, I am a passionate and versatile professional with a strong foundation in both front-end and back-end technologies. With a keen eye for design and a love for problem-solving, I strive to create seamless and intuitive user experiences that bring digital ideas to life.
                        </p> <br />
                        <p className='p-2'>
                            My journey in the world of development began with a curiosity-driven exploration of web technologies, which eventually blossomed into a full-fledged career. Over the years, I have honed my skills in HTML, CSS, JavaScript, and various front-end frameworks to craft visually stunning and responsive websites.
                        </p> <br />
                        <p className="p-3">
                            In building my portfolio, I aim to showcase not only my technical prowess but also my dedication to innovation and my passion for creating digital solutions that solve real-world problems. I take immense pride in my work and look forward to contributing my skills to exciting projects that push the boundaries of technology.
                        </p> <br />
                        <p className="p-4">
                        With a curious mind, a creative spirit, and a dedication to excellence, I am ready to embark on new challenges and make a meaningful impact in the ever-evolving landscape of web development.
                        </p> <br />
                    </div>
                </div>
    
                <div>
                    <h1 className='skill-heading'>
                        <AnimatedLetters strAry={'Skillset'.split('')} letterClass={letterClass} idx={13}/>
                        
                    </h1>
                    <div className="skills"  data-aos="fade-up" >
                        <div>
                            <NavLink target='blank' to={'https://developer.mozilla.org/en-US/docs/Web/HTML'}>
                                <SiHtml5/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://developer.mozilla.org/en-US/docs/Web/CSS'}>
                                <SiCss3/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://developer.mozilla.org/en-US/docs/Web/JavaScript'}>
                                <SiJavascript/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://nodejs.org/it/docs'}>
                                <SiNodedotjs/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://react.dev/'}>
                                <SiReact/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://vitejs.dev/'}>
                                <SiVite/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://nextjs.org/'}>
                                <SiNextdotjs/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://www.npmjs.com/'}>
                                <SiNpm/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://getbootstrap.com/'}>
                                <SiBootstrap/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://tailwindcss.com/'}>
                                <SiTailwindcss/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://www.python.org/'}>
                                <SiPython/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://www.mongodb.com/'}>
                                <SiMongodb/>
                            </NavLink>
                        </div>
                    </div>
                    <h1 className='tools-heading'>
                        <AnimatedLetters strAry={[...'Tools I Use'.split('')]} letterClass={letterClass} idx={13}/>
                    </h1>
                    <div className='tools'  data-aos="fade-up" >
                    <div>
                            <NavLink target='blank' to={'https://www.postman.com/'}>
                                <SiPostman/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://code.visualstudio.com/'}>
                                <SiVisualstudiocode/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://vercel.com'}>
                                <SiVercel/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://stackoverflow.com/'}>
                                <SiStackoverflow/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://practice.geeksforgeeks.org/'}>
                                <SiGeeksforgeeks/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://leetcode.com/'}>
                                <SiLeetcode/>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink target='blank' to={'https://www.freecodecamp.org/'}>
                                <SiFreecodecamp/>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <Loader type='pacman'/>
        </>
    )
}